import React from 'react';
import PropTypes from 'prop-types';
import './Panel.styles.less';

const Panel = ({ items }) => (
  <div className="mpr-panel">
    {items.map((panel, idx) => (
      <div className="mpr-panel__column" key={idx}>
        <div className="mpr-panel__header-group">
          <i className={`mpr-panel__icon ${panel.icon}`} />
          <h3 className="mpr-panel__title">{panel.heading}</h3>
        </div>
        <div className="mpr-panel__body">
          <panel.body {...panel.panelProps} />
        </div>
      </div>
    ))}
  </div>
);

Panel.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({})
  )
};


export default Panel;



// WEBPACK FOOTER //
// ./src/components/manage/website/ManagePagesRedesign/WebAdmin/Panel/Panel.jsx